import React from "react";
import SingleOrder from "../components/SingleOrder";
import Layout from "./Layout";

export default function SingleOrderView(props) {
  return (
    <Layout title="Inhoud Order">
      {" "}
      <SingleOrder />
    </Layout>
    // <div className="pageWrapper">
    //   <Header title="Inhoud Order" />
    //   <div className="contentWrapper fadeInDelayed">
    //     <SingleOrder />
    //   </div>
    //   <BottomNavBar />
    // </div>
  );
}
